import "./TradeOrderComponent.scss";
import {IFormController, IOnChanges, IOnChangesObject, IPostLink} from "angular";
import {PriceStrategy} from "../../../../../../../../components/inputs/price/input/PriceStrategy";
import {PriceStrategyService} from "../../../../../../../../components/inputs/price/service/PriceStrategyService";
import {UserConfig} from "../../../../../../../../types/UserConfig";
import {ClickTarget} from "../../../../../../../../components/trade/trade-detail/spread/ClickTarget";
import {SpreadSummary} from "../../../../../../../../types/OrderSpread";
import {OptionsWizardOrder} from "../../../../../types/OptionsTicket";
import {NumberUtil} from "../../../../../../../../js/util/NumberUtil";
import {SecurityUtil} from "../../../../../../../../js/util/SecurityUtil";
import {OrderValidation} from "../../../../../util/validation/OrderValidation";

import template from "./TradeOrderComponent.html";
import {OrderSide} from "../../../../../../../../orders/models/OrderRecord";

export const TradeDetail = "optionsOrderDetail";

export function tradeDetail() {
    return {
        template,
        bindings: {
            order: "<",
            skipXjoEtrValidation: "<",
            onRemove: "&"
        },
        controllerAs: "ctrl",
        controller: TradeDetailComponentController
    };
}

export class TradeDetailComponentController implements IOnChanges, IPostLink {

    public order: OptionsWizardOrder;
    public skipXjoEtrValidation: boolean | null;

    public spread: SpreadSummary;
    public showEtrLimitWarning = false;
    public tradeForm: IFormController;
    public priceStrategy: PriceStrategy;
    public priceService: PriceStrategyService;

    /** @ngInject */
    public constructor(private userConfig: UserConfig, priceStrategyService: PriceStrategyService) {
        this.priceService = priceStrategyService;
    }

    public $onChanges(changes: IOnChangesObject) {
        if (changes.order != null && this.order != null) {
            this.priceStrategy = this.priceService.forCode(this.order.ticket.code);
            this.spread = this.order.spread;
            this.validatePrice();
        }
    }

    public $postLink() {
        this.validatePrice();
    }

    public setLimit(target: ClickTarget) {
        if (this.order.spread == null) {
            return;
        }
        if (target === ClickTarget.BID) {
            this.setToBid();
        } else {
            this.setToAsk();
        }
    }

    private updateLimit(limit: number) {
        this.order.ticket.limit = this.priceStrategy.round(limit);
        this.validatePrice();
    }

    private setToBid() {
        if (this.order.spread != null) {
            if (this.order.spread.bid != null) {
                this.updateLimit(this.order.spread.bid);
            } else if (this.order.spread.bidLimit != null) {
                this.updateLimit(this.order.spread.bidLimit);
            }
        }
    }

    private setToAsk() {
        if (this.order.spread != null) {
            if (this.order.spread.ask != null) {
                this.updateLimit(this.order.spread.ask);
            } else if (this.order.spread.askLimit != null) {
                this.updateLimit(this.order.spread.askLimit);
            }
        }
    }

    public setLimitToMid() {
        if ((this.spread != null) && (this.spread.mid != null)) {
            this.updateLimit(this.spread.mid);
        }
    }

    private validatePrice() {
        if (this.tradeForm != null && this.order != null && this.spread != null) {
            this.validateTradingState();
            this.validateTradingRange();
        }
    }

    /* This is a terrible fix, but is the only way to make this work right now */
    private quantityChanged() {
        this.order.ticket.buy = this.order.ticket.quantity > 0;
        this.order.side = (this.order.ticket.quantity >= 0 ? OrderSide.BUY : OrderSide.LONG_SELL);
        this.validateTradingRange();
    }

    private validateTradingRange() {
        const isXjo = SecurityUtil.underlying(this.order.ticket.code) === "XJO";

        const orderLimit = this.order.ticket.limit;

        if (!NumberUtil.isValidNumber(orderLimit)) {
            this.updateTradingRangeLimitValidity(true, false);
        } else if (isXjo && this.skipXjoEtrValidation) {
            this.updateTradingRangeLimitValidity(true, false);
        } else {
            const side = this.order.ticket.buy ? OrderSide.BUY : OrderSide.LONG_SELL;
            const validation = OrderValidation.validateEtr(orderLimit, side, this.spread as any, this.userConfig.adviser != null);
            this.updateTradingRangeLimitValidity(!validation.outsideEtr, validation.etrWarning);
        }
    }

    private updateTradingRangeLimitValidity(valid: boolean, etrWarning: boolean) {
        this.tradeForm.$setValidity("trading-range-limit", valid, this.tradeForm);
        this.showEtrLimitWarning = etrWarning;
    }

    private validateTradingState() {
        const notSuspended = this.spread.tradingState !== "S";
        this.tradeForm.$setValidity("trading-state", notSuspended, this.tradeForm);
    }
}
